import { Globe, FileType2, Lock } from 'lucide-react';

import { FileRecord } from '../../types/files';
import { isManagedByModule, buildModuleLabel } from '../../utils/fileMetadata';

interface FileIndicatorsProps {
  file: FileRecord;
}

export const FileIndicators = ({ file }: FileIndicatorsProps) => {
  // Module-managed files take highest precedence
  if (isManagedByModule(file)) {
    const label = buildModuleLabel(file);
    return (
      <div className="rounded-full border border-warning/20 bg-warning/10 px-2 py-1 shadow-sm">
        <div className="flex items-center gap-1">
          <Lock className="size-3 text-warning" />
          {label && (
            <span className="text-[10px] font-medium text-warning">
              {label}
            </span>
          )}
        </div>
      </div>
    );
  }

  // Template takes precedence over public
  if (file.template) {
    return (
      <div className="rounded-full border bg-white p-1 shadow-sm">
        <FileType2 className="size-3 text-success/60" />
      </div>
    );
  }

  if (file.public) {
    return (
      <div className="rounded-full border bg-white p-1 shadow-sm">
        <Globe className="size-3 text-primary/60" />
      </div>
    );
  }

  return null;
};
